// experiment
export const ATTR_EVAL_ID = 'eval.id' as const;
export const ATTR_EVAL_NAME = 'eval.name' as const;
export const ATTR_EVAL_VERSION = 'eval.version' as const;
export const ATTR_EVAL_TYPE = 'eval.type' as const;
export const ATTR_EVAL_TAGS = 'eval.tags' as const;
export const ATTR_EVAL_BASELINE_ID = 'eval.baseline.id' as const;
export const ATTR_EVAL_BASELINE_NAME = 'eval.baseline.name' as const;
export const ATTR_EVAL_BASELINE_VERSION = 'eval.baseline.version' as const;
export const ATTR_EVAL_METADATA = 'eval.metadata' as const;
export const ATTR_EVAL_TRIALS = 'eval.trials' as const;
// capability
export const ATTR_EVAL_CAPABILITY_NAME = 'eval.capability.name' as const;
export const ATTR_EVAL_STEP_NAME = 'eval.step.name' as const;
// collection
export const ATTR_EVAL_COLLECTION_ID = 'eval.collection.id' as const;
export const ATTR_EVAL_COLLECTION_SIZE = 'eval.collection.size' as const;
export const ATTR_EVAL_COLLECTION_NAME = 'eval.collection.name' as const;
// config
export const ATTR_EVAL_CONFIG_FLAGS = 'eval.config.flags' as const;
// case
export const ATTR_EVAL_CASE_INDEX = 'eval.case.index' as const;
export const ATTR_EVAL_CASE_INPUT = 'eval.case.input' as const;
export const ATTR_EVAL_CASE_OUTPUT = 'eval.case.output' as const;
export const ATTR_EVAL_CASE_EXPECTED = 'eval.case.expected' as const;
export const ATTR_EVAL_CASE_SCORES = 'eval.case.scores' as const;
export const ATTR_EVAL_CASE_METADATA = 'eval.case.metadata' as const;
export const ATTR_EVAL_CASE_TRIALS = 'eval.case.trials' as const;
// trial
export const ATTR_EVAL_TRIAL_INDEX = 'eval.trial.index' as const;
export const ATTR_EVAL_TRIAL_ERROR = 'eval.trial.error' as const;
// task
export const ATTR_EVAL_TASK_OUTPUT = 'eval.task.output' as const;
export const ATTR_EVAL_TASK_NAME = 'eval.task.name' as const;
export const ATTR_EVAL_TASK_TYPE = 'eval.task.type' as const;
// run
export const ATTR_EVAL_RUN_ID = 'eval.run.id' as const;
// score
export const ATTR_EVAL_SCORE_NAME = 'eval.score.name' as const;
export const ATTR_EVAL_SCORE_VALUE = 'eval.score.value' as const;
export const ATTR_EVAL_SCORE_THRESHOLD = 'eval.score.threshold' as const;
export const ATTR_EVAL_SCORE_PASSED = 'eval.score.passed' as const;
export const ATTR_EVAL_SCORE_IS_BOOLEAN = 'eval.score.is_boolean' as const;
export const ATTR_EVAL_SCORE_SCORER = 'eval.score.scorer' as const;
export const ATTR_EVAL_SCORE_METADATA = 'eval.score.metadata' as const;
export const ATTR_EVAL_SCORE_AGGREGATION = 'eval.score.aggregation' as const;
export const ATTR_EVAL_SCORE_TRIALS = 'eval.score.trials' as const;
// online
export const ATTR_EVAL_ONLINE_SCORERS_TOTAL = 'eval.online.scorers.total' as const;
export const ATTR_EVAL_ONLINE_SCORERS_RAN = 'eval.online.scorers.ran' as const;
export const ATTR_EVAL_ONLINE_SCORERS_SAMPLED_OUT = 'eval.online.scorers.sampled_out' as const;
export const ATTR_EVAL_ONLINE_SCORERS_FAILED = 'eval.online.scorers.failed' as const;
// user
export const ATTR_EVAL_USER_NAME = 'eval.user.name';
export const ATTR_EVAL_USER_EMAIL = 'eval.user.email';
